import React, { useState, useEffect } from 'react'
import ReactPlayer from 'react-player'
// import RaymsVideo from '../../videos/rayms.mp4'
import GetVideo from './GetVideo';
import {
    VideoWrapper
} from './VideoElements'

const VideoPlayer = (file) => {
    const [videoPath, setVideoPath] = useState({ fileUrl: '' });
    const [videoStatus, setVideoStatus] = useState(false)

    useEffect(() => {
        const videoWait = async () => {
            const videoInWait = await GetVideo(file).then(vid => vid)
            setVideoPath({ fileUrl: videoInWait });
            setVideoStatus(true);
        }
        videoWait()
            .catch(console.error());;
    }, []);

    return (
        <VideoWrapper>
            {videoStatus ? (
                <ReactPlayer
                    className='react-player'
                    url={videoPath.fileUrl}
                    width='50%'
                    height='50%'
                    controls={true}
                />) :
                <ReactPlayer />
            }
        </VideoWrapper>
    )
}

export default VideoPlayer